export const GET_CONTACTS = 'GET_CONTACTS';
export const GET_PROJECTS = 'GET_PROJECTS';
export const BROADCAST_NOTIFICATION = 'BROADCAST_NOTIFICATION';
export const BROADCAST_NOTIFICATION_USER_LIST = 'BROADCAST_NOTIFICATION_USER_LIST';
